var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueIcons2008(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.122,
    height: 52.087,
    viewBox: "0 0 27.122 52.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BlueIcons_-20-08",
    "data-name": "BlueIcons -20-08",
    transform: "translate(-30.407 0.608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(30.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    transform: "translate(0 24.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2966",
    "data-name": "Path 2966",
    d: "M206.286,167.8a12.784,12.784,0,0,0-2.822,16.78c1.411-.061,2.838-.107,4.28-.153Z",
    transform: "translate(-201.5 -167.432)",
    fill: "none",
    stroke: "#0561fc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2967",
    "data-name": "Path 2967",
    d: "M329.288,165.4l-1.488,17c1.611.046,3.221.092,4.786.169a12.809,12.809,0,0,0-3.3-17.164Z",
    transform: "translate(-308.427 -165.4)",
    fill: "none",
    stroke: "#0561fc",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2968",
    "data-name": "Path 2968",
    d: "M231.75,44.069h13.513l1.6-18.222A19.516,19.516,0,0,0,238.514,8.1a19.435,19.435,0,0,0-8.344,17.747Z",
    transform: "translate(-225.707 -8.1)",
    fill: "none",
    stroke: "#0561fc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2969",
    "data-name": "Path 2969",
    d: "M270.827,275.814c0,1.718-3.114,7.271-3.114,7.271,0,.123-3.114-5.537-3.114-7.271a3.114,3.114,0,1,1,6.227,0Z",
    transform: "translate(-254.921 -232.114)",
    fill: "none",
    stroke: "#0561fc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2970",
    "data-name": "Path 2970",
    d: "M251.12,14.389a32.851,32.851,0,0,1,6.1.568,19.569,19.569,0,0,0-6.1-6.856A19.611,19.611,0,0,0,245,14.956,33.265,33.265,0,0,1,251.12,14.389Z",
    transform: "translate(-238.328 -8.1)",
    fill: "none",
    stroke: "#0561fc",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2971",
    "data-name": "Path 2971",
    d: "M265.074,75.487a4.387,4.387,0,1,1-4.387-4.387A4.386,4.386,0,0,1,265.074,75.487Z",
    transform: "translate(-247.894 -61.437)",
    fill: "#c5e1f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_128",
    "data-name": "Line 128",
    x2: 15.062,
    transform: "translate(5.261 31.812)",
    fill: "none",
    stroke: "#0561fc",
    strokeWidth: 1
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueIcons2008);
export default __webpack_public_path__ + "static/media/BlueIcons -20-08.f030b4c2b8132199ccd66aff611f472b.svg";
export { ForwardRef as ReactComponent };